import React, { memo } from "react";

export default memo(function PopupHeader({ title }) {
  return (
    <div style={{ padding: "21px 20px" }}>
      <p style={{ fontSize: 12, fontWeight: "bold", margin: 0, textTransform: 'capitalize' }}>{title}</p>
    </div>
  );
});
